import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useMemo } from 'react';
import { styled } from '@mui/material/styles';
import { useLocalizationContext, Translate } from '@im/react-localization';
import { SelectOption } from '../SelectOption/SelectOption';
import { jsx as _jsx } from "react/jsx-runtime";
export function CulturePicker(props) {
  var context = useLocalizationContext();
  var supportedLocales = context.supportedLocales;
  var _props$dataTestid = props['data-testid'],
    testid = _props$dataTestid === void 0 ? 'required' : _props$dataTestid;
  var options = useMemo(function () {
    return supportedLocales ? supportedLocales.map(function (locale) {
      return {
        label: /*#__PURE__*/_jsx(Translate, {
          text: "Culture.".concat(locale)
        }),
        value: locale
      };
    }) : [];
  }, [supportedLocales]);
  if (!supportedLocales || supportedLocales.length < 2) {
    return null;
  }
  return /*#__PURE__*/_jsx(StyleSelectOption, _extends({
    onChange: function onChange(e) {
      context.setLocale(e.target.value);
    },
    options: options,
    value: context.locale
  }, props, {
    "data-testid": "".concat(testid, "-CulturePicker"),
    "data-element": "StyleSelectOption",
    "data-component": "CulturePicker",
    "data-source-file": "CulturePicker.tsx"
  }));
}
var StyleSelectOption = styled(SelectOption)(function (_ref) {
  var theme = _ref.theme;
  return {
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none'
    },
    '& .MuiSelect-icon': {
      color: 'inherit'
    },
    color: theme.palette.text.secondary,
    fontSize: 14,
    fontWeight: theme.typography.fontWeightMedium,
    maxWidth: '350px',
    minWidth: '100px',
    width: 'auto'
  };
});